/* unplugin-vue-components disabled */import { render } from "./w-date-picker.vue?vue&type=template&id=2b0e6097&ts=true"
import script from "./w-date-picker.vue?vue&type=script&lang=ts"
export * from "./w-date-picker.vue?vue&type=script&lang=ts"

import "./w-date-picker.vue?vue&type=style&index=0&id=2b0e6097&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__